import definition from './definition.json';

export default { definition };
